import type { Entity } from '@backstage/catalog-model';
import type { EntityFilter } from '@backstage/plugin-catalog-react';

export class EntitySpecFilter<
  T extends Entity['spec'],
> implements EntityFilter {
  toQueryValue?: () => string | string[];

  constructor(
    readonly specField: keyof T,
    readonly value: T[keyof T] | T[keyof T][],
    readonly hideQueryParam = false,
  ) {
    this.toQueryValue = this.hideQueryParam
      ? undefined
      : () => {
          if (Array.isArray(this.value)) {
            return this.value.map(String);
          }
          return String(this.value);
        };
  }

  filterEntity(entity: Entity): boolean {
    const fieldValue = entity.spec?.[this.specField as string];
    if (fieldValue === undefined) {
      return false;
    }
    const values = Array.isArray(this.value) ? this.value : [this.value];
    return values.includes(fieldValue as T[keyof T]);
  }
}
